import React, { useState, useEffect } from "react";
import { addAdminUser } from "../../../Services/postServices";
import { getZoneList } from "../../../Services/getServices";
import { ssoRoleBydomain } from "../../../Services/getServices";
import { loader } from "../../../redux/type";
import { useDispatch } from "react-redux";
// import AddAdmin from "../AddAdmin";
import { toast } from "react-toastify";
import Select from "react-select";

const AdminBhoomi = (props) => {
  const mobNum = localStorage.getItem("moblie");
  const dispatch = useDispatch();
  console.log("DOMAINCIODE=", props?.data?.domainCode);
  // const roles=props?.data?.rolesList;
  const domainC = props?.data?.domainCode;
  const userData = JSON.parse(localStorage.getItem("user"));
  //   console.log("DATATATA=", userData?.user?.id);
  // const id=userData?.user?.id

  const id = userData?.domainCodesByUserId[0]?.userId;

  var [name, setName] = useState("");

  var [mobileNo, setMobileNo] = useState("");

  var [email, setEmail] = useState("");
  var [dept, setDept] = useState("");
  var [desig, setDesig] = useState("");
  var [zone, setZone] = useState("");
  var [cat, setCat] = useState("");
  var [userId, setUserId] = useState("");
  var [pass, setPass] = useState("");
  var [zoneArr, setZoneArr] = useState([]);
  var [rolesList, setRolesList] = useState([]);

  useEffect(() => {
    zoneList();
    // deptByDomainName();
    ssoRoleByDomainName(domainC);
    // ssoRoleBydeptId();
    // desigByDomainName();
    // desigByDeptId();
  }, []);

  const options = [
    { value: 1, label: "Apple" , zoneName:"ABC"},
    { value: 2, label: "Banana",zoneName:"ABC" },
    { value: 3, label: "Cherry",zoneName:"ABC" },
  ];


  const zoneee= [
    {
        "id": 1,
        "zoneCode": "G",
        "zoneName": "Not Given",
        "refStatusId": 1,
        "createdBy": 1,
        "createdAt": "2020-03-12T01:03:15.000+00:00",
        "updatedBy": 1,
        "updatedAt": "2020-03-12T01:03:15.000+00:00",
        "isDeleted": 0
    },
    {
        "id": 2,
        "zoneCode": "W",
        "zoneName": "WEST",
        "refStatusId": 1,
        "createdBy": 1,
        "createdAt": "2020-03-12T01:03:15.000+00:00",
        "updatedBy": 1,
        "updatedAt": "2020-03-12T01:03:15.000+00:00",
        "isDeleted": 0
    },
    {
        "id": 3,
        "zoneCode": "N",
        "zoneName": "NORTH",
        "refStatusId": 1,
        "createdBy": 1,
        "createdAt": "2020-03-12T01:03:15.000+00:00",
        "updatedBy": 1,
        "updatedAt": "2020-03-12T01:03:15.000+00:00",
        "isDeleted": 0
    },
    {
        "id": 4,
        "zoneCode": "R",
        "zoneName": "ROHINI",
        "refStatusId": 1,
        "createdBy": 1,
        "createdAt": "2020-03-12T01:03:15.000+00:00",
        "updatedBy": 1,
        "updatedAt": "2020-03-12T01:03:15.000+00:00",
        "isDeleted": 0
    },
    {
        "id": 5,
        "zoneCode": "S",
        "zoneName": "SOUTH",
        "refStatusId": 1,
        "createdBy": 1,
        "createdAt": "2020-03-12T01:03:15.000+00:00",
        "updatedBy": 1,
        "updatedAt": "2020-03-12T01:03:15.000+00:00",
        "isDeleted": 0
    },
    {
        "id": 6,
        "zoneCode": "E",
        "zoneName": "EAST",
        "refStatusId": 1,
        "createdBy": 1,
        "createdAt": "2020-03-12T01:03:15.000+00:00",
        "updatedBy": 1,
        "updatedAt": "2020-03-12T01:03:15.000+00:00",
        "isDeleted": 0
    },
    {
        "id": 7,
        "zoneCode": "A",
        "zoneName": "SOUTH EAST",
        "refStatusId": 1,
        "createdBy": 1,
        "createdAt": "2020-03-12T01:03:15.000+00:00",
        "updatedBy": 1,
        "updatedAt": "2020-03-12T01:03:15.000+00:00",
        "isDeleted": 0
    },
    {
        "id": 8,
        "zoneCode": "B",
        "zoneName": "SOUTH WEST",
        "refStatusId": 1,
        "createdBy": 1,
        "createdAt": "2020-03-12T01:03:15.000+00:00",
        "updatedBy": 1,
        "updatedAt": "2020-03-12T01:03:15.000+00:00",
        "isDeleted": 0
    },
    {
        "id": 9,
        "zoneCode": "C",
        "zoneName": "CENTRAL",
        "refStatusId": 1,
        "createdBy": 1,
        "createdAt": "2020-03-12T01:03:15.000+00:00",
        "updatedBy": 1,
        "updatedAt": "2020-03-12T01:03:15.000+00:00",
        "isDeleted": 0
    },
    {
        "id": 10,
        "zoneCode": "D",
        "zoneName": "WEST/DWARKA",
        "refStatusId": 1,
        "createdBy": 1,
        "createdAt": "2020-06-16T22:24:54.000+00:00",
        "updatedBy": 1,
        "updatedAt": "2020-06-16T22:24:54.000+00:00",
        "isDeleted": 0
    },
    {
        "id": 11,
        "zoneCode": "NW",
        "zoneName": "North West",
        "refStatusId": 1,
        "createdBy": 1,
        "createdAt": "2021-07-24T19:50:44.000+00:00",
        "updatedBy": 1,
        "updatedAt": "2021-07-24T19:50:44.000+00:00",
        "isDeleted": 0
    },
    {
        "id": 12,
        "zoneCode": "SFS",
        "zoneName": "SFS",
        "refStatusId": 1,
        "createdBy": 1,
        "createdAt": "2021-10-22T00:34:39.000+00:00",
        "updatedBy": 1,
        "updatedAt": "2021-10-22T00:34:39.000+00:00",
        "isDeleted": 0
    },
    {
        "id": 13,
        "zoneCode": "NZ",
        "zoneName": "Narela",
        "refStatusId": 1,
        "createdBy": 1,
        "createdAt": null,
        "updatedBy": 1,
        "updatedAt": null,
        "isDeleted": 0
    }
]
  const [selectedValues, setSelectedValues] = useState([]);
  

  const handleChange = (selected) => {
    
    // const valuesOnly = selected ? selected.map((opt) => opt.value) : [];
    const valuesOnly = selected ? selected.map((opt) => opt.value) : [];
    setSelectedValues(valuesOnly);
  };
  const selectedOptionObjects = options.filter((opt) =>
    selectedValues.includes(opt.value)
  );


  const [selectedZone, setSelectedZone] = useState([]);
  const handleZone = (selected) => {
    
    // const valuesOnly = selected ? selected.map((opt) => opt.value) : [];
    const valuesOnly1 = selected ? selected.map((opt) => opt.id) : [];
    setSelectedZone(valuesOnly1);
  };
  const selectedZoneObjects = zoneArr.filter((opt) =>
    selectedZone.includes(opt.id)
  );

  


  // const selectedOptionObjects = options.filter((opt) =>
  //   selectedValues.includes(opt.id)
  // );
console.log("ZONES=",selectedZone);
console.log("ZONES=",zoneArr)

  function ssoRoleByDomainName(domainCo) {
    ssoRoleBydomain(domainCo, (res) => {
      if (res?.data?.status) {
        setRolesList(res?.data?.result);
        console.log("roless", res?.data?.result);
      } else {
      }
    });
  }

  function zoneList() {
    dispatch({ type: loader.startLoader });

    getZoneList((res) => {
      dispatch({ type: loader.stopLoader });
      if (res?.data?.status) {
        setZoneArr(res?.data?.result);
        console.log("ZONE=",res?.data?.result)
      } else {
      }
    });
  }

  function addUser() {
    let req = {
      userName: userId,
      createdBy: id.toString(),

      emailId: email,

      mobileNumber: mobileNo,

      firstName: name,

      zone: zone,
      domainCode: domainC,

      designation: desig,
      isAdmin: "Y",
      roles: [4],
      userType: "1",

      password: pass,
      retypePassword: pass,

      departmentName: domainC,

      isAdmin: "Y",
      // "roles":[1,2,3,4],
      dob: "2005-02-02",
    };
    dispatch({ type: loader.startLoader });
    addAdminUser(req, (res) => {
      dispatch({ type: loader.stopLoader });
      if (res?.data?.status) {
        toast.success(res?.data?.message);
        window.location.reload();
      } else {
        toast.error(res?.data?.message);
      }
    });
  }

  return (
    <>
      <div className="row ">
 {/* <Select
              isMulti
            
              options={options}
              value={selectedOptionObjects}
              getOptionLabel={(e)=>e.zoneName}
              onChange={handleChange}
              placeholder="Select Zone"
            />

            <Select
              isMulti
            
              options={zoneArr
                
              }
              value={selectedZoneObjects}
              getOptionLabel={(e)=>e.zoneName}
              onChange={handleZone}
              placeholder="Select Zone"
            /> */}


        <div className="col-4">
          <div className="form-outline mb-3">
            <label className="form-label" for="id">
              Name:
            </label>
            <input
              type="mobile"
              id="aadhaarcard"
              onChange={(e) => setName(e.target.value)}
              className="form-control"
              placeholder="Enter here"
            />
          </div>
        </div>

        <div className="col-4">
          <div className="form-outline mb-3">
            <label className="form-label" for="id">
              Mobile Number:
            </label>
            <input
              type="mobile"
              onChange={(e) => setMobileNo(e.target.value)}
              // value={mobNum}
              //   disabled
              className="form-control"
              placeholder="Enter here"
            />
          </div>
        </div>
        <div className="col-4">
          <div className="form-outline mb-3 ">
            <label className="form-label" for="id">
              Email:
            </label>
            <input
              type="mobile"
              onChange={(e) => setEmail(e.target.value)}
              className="form-control"
              placeholder="Enter here"
            />
          </div>
        </div>

        {/* <div className="col-4">
          <div className="form-outline mb-3 ">
            <label className="form-label" for="id">
              Department Name:
            </label>
            <input
              type="mobile"
              onChange={(e) => setDept(e.target.value)}
              className="form-control"
              placeholder="Enter here"
            />
          </div>
        </div> */}
        <div className="col-4">
          <div className="form-outline mb-3 ">
            <label className="form-label" for="id">
              Designation :
            </label>

           

            <select
              class="form-control form-select"
              onChange={(e) => {
                setDesig(e.target.value);
              }}
            >
              <option value="0">Select Designation </option>

              {rolesList.map((val) => {
                return (
                  <option key={val} value={val.roleId}>
                    {val.roleName}
                  </option>
                );
              })}
            </select>
          </div>
        </div>

        <div className="col-4">
          <div className="form-outline mb-3 ">
            <label className="form-label" for="id">
              Zone:
            </label>
            <select
              class="form-control form-select"
              onChange={(e) => {
                setZone(e.target.value);
              }}
            >
              <option value="0">Select Domain </option>

              {zoneArr.map((val) => {
                return (
                  <option key={val} value={val.id}>
                    {val.zoneName}
                  </option>
                );
              })}
            </select>


          </div>
        </div>

        {/* <div className="col-4">
          <div className="form-outline mb-3">
            <label className="form-label" for="id">
              Category:
            </label>
            <input
              type="mobile"
              onChange={(e) => setCat(e.target.value)}
              className="form-control"
              placeholder="Enter here"
            />
          </div>
        </div> */}
        <div className="col-4">
          <div className="form-outline mb-3">
            <label className="form-label" for="id">
              User Id:
            </label>
            <input
              type="mobile"
              onChange={(e) => setUserId(e.target.value)}
              className="form-control"
              placeholder="Enter here"
            />
          </div>
        </div>
        <div className="col-4">
          <div className="form-outline mb-3">
            <label className="form-label" for="id">
              Password:
            </label>
            <input
              type="mobile"
              onChange={(e) => setPass(e.target.value)}
              className="form-control"
              placeholder="Enter here"
            />
          </div>
        </div>

        <div className="col-4 " >
          <div className="form-outline" style={{marginTop:"2rem"}}>
            <button className="btn btn-primary" onClick={addUser}>
              Create Admin
            </button>
          </div>
        </div>
      </div>
    </>
  );
};
export default AdminBhoomi;
